import React from "react";

import Box from "@mui/material/Box";
import { type SxProps, keyframes } from "@mui/material/styles";
import styled from "@mui/material/styles/styled";

const blink = keyframes`
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
`;

const TypingIndicatorWrapper = styled(Box)({
  display: "inline-flex",
  gap: "3px",
  verticalAlign: "middle",
  height: "6px"
});

interface DotProps {
  delay: string;
}

const Dot = styled(Box)<DotProps>(({ delay }: DotProps) => ({
  width: "6px",
  height: "6px",
  backgroundColor: "gray",
  borderRadius: "50%",
  display: "inline-block",
  animation: `${blink} 1.5s infinite ease-in-out`,
  animationDelay: delay
}));

interface TypingIndicatorV2Props {
  sx?: SxProps;
}

export default function TypingIndicatorV2({ sx }: TypingIndicatorV2Props) {
  return (
    <TypingIndicatorWrapper sx={sx}>
      <Dot delay="0s" />
      <Dot delay="0.2s" />
      <Dot delay="0.4s" />
    </TypingIndicatorWrapper>
  );
}
